import { boolean, object, string } from 'yup';

export const MIN_SEARCH_LENGTH = 2;
export const FREE_QUOTA_DEFAULT = 0;
export const PRICE_PERCENTAGE_DEFAULT = 0;

export const createOrganizationValidationSchema = object({
  organizationName: string().required('Organization name is required'),
  hasParentOrg: boolean(),
  parentOrganizationID: string().when('hasParentOrg', {
    is: true,
    then: (schema) => schema.required('Parent organization is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
});
